import { forwardRef, type InputHTMLAttributes } from 'react';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ label, checked, onChange, className = '', disabled = false, ...props }, ref) => {
    return (
      <label className={`switch-control ${disabled ? 'disabled' : ''} ${className}`.trim()} title={label}>
        <input
          {...props}
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={label}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span className="switch-track" aria-hidden="true">
          <span />
        </span>
      </label>
    );
  },
);

Switch.displayName = 'Switch';
